import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Scissors } from 'lucide-react';
function getWhatsAppLink(barberName: string) {
  const message = encodeURIComponent(`Hola, vengo desde la web y quiero reservar una cita con ${barberName}`);
  return `https://wa.me/573054520211?text=${message}`;
}
const barbers = [{
  id: 1,
  name: 'Carlos',
  title: 'Barbero Senior',
  specialty: 'Especialista en fades y diseños',
  initials: 'C'
}, {
  id: 2,
  name: 'Andrés',
  title: 'Barbero Profesional',
  specialty: 'Experto en barba y corte clásico',
  initials: 'A'
}, {
  id: 3,
  name: 'Miguel',
  title: 'Barbero Creativo',
  specialty: 'Especialista en tendencias y color',
  initials: 'M'
}];
export function BarbersSection() {
  return <section id="barberos" className="py-12 md:py-24 bg-brand-dark border-t border-brand-card" data-id="element-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="text-center mb-8 md:mb-16" data-id="element-12">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-playfair text-white mb-4 relative inline-block" data-id="element-13">
            Nuestros Barberos
            <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-brand-gold rounded-full" data-id="element-14"></div>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-brand-gray mt-6 text-lg" data-id="element-15">
            Profesionales apasionados por su arte
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-16">
          {barbers.map((barber, index) => <motion.div key={barber.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-brand-black rounded-sm p-5 md:p-8 border border-brand-card hover:border-brand-gold/30 transition-colors text-center group" data-id="element-17">
              <div className="w-32 h-32 mx-auto bg-brand-card rounded-full flex items-center justify-center border-2 border-brand-gold/20 mb-6 group-hover:border-brand-gold transition-colors relative overflow-hidden" data-id="element-18">
                <div className="absolute inset-0 bg-brand-gold/5 group-hover:bg-brand-gold/10 transition-colors" data-id="element-19"></div>
                <span className="text-4xl font-playfair text-brand-gold opacity-50 absolute" data-id="element-20">
                  {barber.initials}
                </span>
                <Scissors className="w-10 h-10 text-brand-gold relative z-10" data-id="element-21" />
              </div>

              <h3 className="text-2xl font-playfair text-white mb-1" data-id="element-22">
                {barber.name}
              </h3>
              <p className="text-brand-gold text-sm font-medium uppercase tracking-wider mb-3" data-id="element-23">
                {barber.title}
              </p>
              <p className="text-brand-gray text-sm mb-4 md:mb-8 h-auto md:h-10" data-id="element-24">
                {barber.specialty}
              </p>

              <a href={getWhatsAppLink(barber.name)} target="_blank" rel="noopener noreferrer" className="inline-block w-full btn-gold px-6 py-3" data-id="element-25">
                Reservar con {barber.name}
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}